<template>
  <div class="form-item-desc">
    <div class="form-item-desc__form-item">
      <slot></slot>
    </div>
    <span class="form-item-desc__desc">
      <slot name="desc"></slot>
    </span>
  </div>
</template>

<script>
export default {}
</script>

<style lang="stylus">
  .form-item-desc{
    display relative
    &__desc{
      position absolute
      left 0
      right 0
      top 100%
      display block
      line-height 1rem
      font-size 1.2rem
      font-weight 300
      color #00749c
      padding 0.5rem 0
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
      position absolute
    }
  }
  .material-style.is-error{
    .form-item-desc{
      &__desc{
        display none
      }
    }
  }
</style>
